export type InvitationStatus =
  | "invited"
  | "already_exists"
  | "re_sent"
  | "skipped"
  | "failed";

export interface InvitationResult {
  email: string;
  errorCode?: string;
  reason?: string;
  status: InvitationStatus;
  userStatus?: string;
}

export interface InviteSaveResult<T> {
  invitations?: InvitationResult[];
  item: T;
  saved: boolean;
}

export function describeInvitationResults(
  invitations: InvitationResult[] | undefined
): string {
  return (invitations || [])
    .map(describeInvitation)
    .filter(Boolean)
    .join("\n");
}

export function hasInvitationWarning(
  invitations: InvitationResult[] | undefined
): boolean {
  return (invitations || []).some(
    (invitation) =>
      invitation.status === "failed" || invitation.status === "skipped"
  );
}

function describeInvitation(invitation: InvitationResult): string {
  switch (invitation.status) {
    case "invited":
      return `Invitation sent to ${invitation.email}`;
    case "already_exists":
      return `${invitation.email} already has a Cognito account`;
    case "re_sent":
      return `Invitation re-sent to ${invitation.email}`;
    case "skipped":
      return `Invitation skipped for ${invitation.email}: ${invitation.reason || "not eligible"}`;
    case "failed":
      return `Invitation failed for ${invitation.email}: ${invitation.reason || "Cognito error"}`;
    default:
      return "";
  }
}
